import { jsx as _jsx } from "react/jsx-runtime";
var HelperText = function HelperText(_ref) {
  var text = _ref.text,
    inputId = _ref.inputId,
    hasError = _ref.hasError;
  return hasError ? /*#__PURE__*/_jsx("p", {
    id: "".concat(inputId, "Error"),
    role: "alert",
    className: "tw-font-caption tw-text-alert-400 dark:tw-text-alert-300",
    children: text
  }) : /*#__PURE__*/_jsx("p", {
    className: "tw-font-caption tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
    children: text
  });
};
export default HelperText;